import { DeathCancellationAnscNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import CancellationDeathNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-death/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const CancellationDeathNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <CancellationDeathNotificationCivilStatusShared
        scope={IdAmbito.Cancellazioni}
        items={DeathCancellationAnscNotificationsResidentCancellationsCrumbs()}
      />
    </Fragment>
  );
};

CancellationDeathNotificationCivilStatusPage.displayName =
  'Cancellation Death Notification Page component';

export default CancellationDeathNotificationCivilStatusPage;
